// extracted by mini-css-extract-plugin
export default {"root":"MentionInput_root__miNBp","invalid":"MentionInput_invalid__DJGrW","disabled":"MentionInput_disabled__bEj6Z","mention-input":"MentionInput_mention-input__cTnA0"};